import React from 'react';
import styles from './styles.scss';
export var handleSort = function handleSort(sortDirection, activeSortDirection, sortActive, onSortAsc, onSortDesc, onClearSort) {
  return function () {
    if (sortActive && sortDirection === activeSortDirection) {
      onClearSort();
    } else if (sortDirection === 'ASC') {
      onSortAsc();
    } else {
      onSortDesc();
    }
  };
};
export var SortOptions = function SortOptions(_ref) {
  var sortDirection = _ref.sortDirection,
      sortActive = _ref.sortActive,
      ascText = _ref.ascText,
      descText = _ref.descText,
      onSortAsc = _ref.onSortAsc,
      onSortDesc = _ref.onSortDesc,
      onClearSort = _ref.onClearSort;
  return React.createElement(React.Fragment, null, React.createElement("button", {
    className: styles.sortOption,
    "data-test": "sort-asc-button",
    onClick: handleSort('ASC', sortDirection, sortActive, onSortAsc, onSortDesc, onClearSort)
  }, sortActive && sortDirection === 'ASC' ? 'Remove  ' : '', ascText), React.createElement("button", {
    className: styles.sortOption,
    "data-test": "sort-desc-button",
    onClick: handleSort('DESC', sortDirection, sortActive, onSortAsc, onSortDesc, onClearSort)
  }, sortActive && sortDirection === 'DESC' ? 'Remove  ' : '', descText));
};
SortOptions.defaultProps = {
  ascText: 'Asc',
  descText: 'Desc',
  sortActive: false,
  onSortAsc: function onSortAsc() {},
  onSortDesc: function onSortDesc() {},
  onClearSort: function onClearSort() {}
};